module.exports = __webpack_public_path__ + "img/claude.372235dc.svg";